module.exports = __webpack_public_path__ + "static/media/threat-statement.282a6564.svg";